import React, { useEffect, useState, useCallback } from 'react';
import { adminApi } from '../../services/api';
import toast from 'react-hot-toast';
import { Upload, Trash2, FileText, Download } from 'lucide-react';

export default function AdminContracts() {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [form, setForm] = useState({ name: '', description: '', file: null });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await adminApi.getContracts();
      setContracts(res.data.results || res.data);
    } catch { toast.error('Error al cargar.'); }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!form.name || !form.file) {
      toast.error('Nombre y archivo son obligatorios.');
      return;
    }
    setUploading(true);
    try {
      await adminApi.uploadContract(form);
      toast.success('Contrato subido correctamente.');
      setForm({ name: '', description: '', file: null });
      load();
    } catch { toast.error('Error al subir.'); }
    setUploading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este contrato?')) return;
    try {
      await adminApi.deleteContract(id);
      toast.success('Contrato eliminado.');
      load();
    } catch { toast.error('Error al eliminar.'); }
  };

  // La API devuelve URLs absolutas; no se antepone ningún prefijo.

  return (
    <div>
      <div className="page-header">
        <h1>Contratos</h1>
        <p>Sube contratos para que los nuevos empleados puedan descargarlos</p>
      </div>

      {/* Upload form */}
      <div className="card" style={{ marginBottom: 24 }}>
        <h3 className="card__title"><Upload size={18} style={{ verticalAlign: 'middle', marginRight: 6 }} />Subir nuevo contrato</h3>
        <form onSubmit={handleUpload}>
          <div className="form-row">
            <div className="form-group">
              <label>Nombre del contrato *</label>
              <input className="form-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Ej: Contrato tipo jornada completa" />
            </div>
            <div className="form-group">
              <label>Archivo *</label>
              <input type="file" className="form-input" accept=".pdf,.doc,.docx" onChange={e => setForm({ ...form, file: e.target.files[0] })} style={{ padding: 8 }} />
            </div>
          </div>
          <div className="form-group">
            <label>Descripción (opcional)</label>
            <input className="form-input" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
          </div>
          <button type="submit" className="btn btn--primary" disabled={uploading}>
            <Upload size={16} /> {uploading ? 'Subiendo...' : 'Subir contrato'}
          </button>
        </form>
      </div>

      {/* List */}
      {loading ? <div className="spinner" /> : (
        <div className="card">
          <h3 className="card__title">Contratos disponibles</h3>
          {contracts.length === 0 ? (
            <div className="empty-state"><p>No hay contratos cargados</p></div>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Fecha</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {contracts.map(c => (
                  <tr key={c.id}>
                    <td style={{ fontWeight: 500 }}>
                      <FileText size={14} style={{ verticalAlign: 'middle', marginRight: 6 }} />
                      {c.name}
                    </td>
                    <td style={{ fontSize: '0.84rem', color: 'var(--gray-500)' }}>{c.description || '—'}</td>
                    <td>{new Date(c.uploaded_at).toLocaleDateString('es-ES')}</td>
                    <td>
                      <span className={`badge ${c.is_active ? 'badge--success' : 'badge--neutral'}`}>
                        {c.is_active ? 'Activo' : 'Inactivo'}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <a href={c.file} target="_blank" rel="noreferrer" className="btn btn--ghost btn--sm">
                          <Download size={14} />
                        </a>
                        <button className="btn btn--ghost btn--sm" onClick={() => handleDelete(c.id)}>
                          <Trash2 size={14} color="var(--danger)" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
